import useInitialData from '@page-components/Layout/useInitialData'

export default function useShouldUseNewAddressesUI() {
  const initialData = useInitialData()

  return initialData.website?.shouldUseNewAddressesUI
}
